/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from 'src/utils/notification';

export  const onFailure = (args: any) => {
  if (args.e.currentTarget.statusText !== '')
    toast.error('', args.e.currentTarget.statusText);
};
